export default __webpack_public_path__ + "static/media/token-migration.39cec301.svg";